var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5498 2.09922C4.5498 1.74023 4.84082 1.44922 5.1998 1.44922H13.8998C14.2588 1.44922 14.5498 1.74023 14.5498 2.09922V10.7992C14.5498 11.1582 14.2588 11.4492 13.8998 11.4492H5.1998C4.84082 11.4492 4.5498 11.1582 4.5498 10.7992V2.09922ZM5.8498 2.74922V10.1492H13.2498V2.74922H5.8498Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94941 4.05078V13.0508H11.9494V14.3508H2.29941C1.94043 14.3508 1.64941 14.0598 1.64941 13.7008V4.05078H2.94941Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.c55985dd9b08e62937dc38db7be2eaa5.svg";
export { ForwardRef as ReactComponent };